import { Component, OnInit } from '@angular/core';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

import { Http, Response } from '@angular/http';
import { WpService } from '../service/wp.service';


@Component({
  selector: 'app-bilder',
  templateUrl: './bilder.component.html',
  styleUrls: ['./bilder.component.scss']
})
export class BilderComponent implements OnInit {

  page: {};
  loaded: boolean;
  images: any;
  imgId = 0;

  constructor(private http: Http, private wp: WpService) { }

  ngOnInit() {
    this.page = undefined
    this.loaded = false;
    this.wp.get('page/bilder').subscribe(
      data => {
        this.page = data
        // if(this.page['blog']){
        //   this.page['blog']["post_content"] = this.page['blog']["post_content"].split('<!--more-->')[0]
        // }
      },
      error => {
        console.error(error)
      }
    )
    this.http.get("/wp-json/wp/v2/media/?categories=12").subscribe(
      data => {
        this.images = data.json()
        setInterval(() => {
          this.imgId = (this.imgId + 1) % this.images.length;
        }, 5000)
      }
    )
  }

  ngAfterViewInit(){

  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/bilder/bilder.component.ts